import React from 'react';
import Icon from '../../../components/AppIcon';

const VerseEngagement = ({ users = [], maxDisplay = 4, className = '' }) => {
  if (!users || users?.length === 0) return null;

  const displayedUsers = users?.slice(0, maxDisplay);
  const overflowCount = users?.length - maxDisplay;

  const getAvatarDataUrl = (svg) => {
    if (!svg) return null;
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {/* User Avatars */}
      <div className="flex items-center -space-x-2">
        {displayedUsers?.map((user, index) => {
          const avatarUrl = getAvatarDataUrl(user?.avatarSvg);
          const hasReflection = user?.engagementTypes?.includes('reflection');
          const hasMemorization = user?.engagementTypes?.includes('memorization');
          
          return (
            <div
              key={user?.userId}
              className="relative group"
              style={{ zIndex: maxDisplay - index }}
            >
              {/* Avatar */}
              <div className="w-7 h-7 rounded-full border-2 border-background bg-muted overflow-hidden shadow-sm hover:scale-110 transition-transform duration-200 cursor-pointer">
                {avatarUrl ? (
                  <img
                    src={avatarUrl}
                    alt={user?.username || 'User avatar'}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-primary/10">
                    <Icon name="User" size={14} className="text-primary" />
                  </div>
                )}
              </div>

              {/* Tooltip */}
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-popover border border-border text-popover-foreground text-xs rounded whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pointer-events-none z-[100] shadow-md">
                <div className="font-medium text-foreground">{user?.username || 'Anonymous'}</div>
                <div className="text-muted-foreground text-[10px] flex items-center gap-1 mt-0.5">
                  {hasReflection && (
                    <span className="flex items-center gap-0.5">
                      <Icon name="MessageSquare" size={10} />
                      Reflected
                    </span>
                  )}
                  {hasReflection && hasMemorization && <span>•</span>}
                  {hasMemorization && (
                    <span className="flex items-center gap-0.5">
                      <Icon name="BookMarked" size={10} />
                      Memorizing
                    </span>
                  )}
                </div>
                {/* Tooltip arrow */}
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-border" />
              </div>
            </div>
          );
        })}
      </div>

      {/* Overflow Count */}
      {overflowCount > 0 && (
        <div className="flex items-center justify-center w-7 h-7 rounded-full bg-muted border-2 border-background text-xs font-medium text-muted-foreground shadow-sm">
          +{overflowCount}
        </div>
      )}

      {/* Engagement Label */}
      <span className="text-xs text-muted-foreground ml-1">
        {users?.length === 1 ? '1 user' : `${users?.length} users`}
      </span>
    </div>
  );
};

export default VerseEngagement;